import UcSuggestRegisterEntryOption from './UcSuggestRegisterEntryOption.yaml?component';
import UcRegisterEntryMiniCard from './UcRegisterEntryMiniCard.yaml?component';
import UcRegisterSelector from './UcRegisterSelector.yaml?component';

export {
  UcSuggestRegisterEntryOption,
  UcRegisterEntryMiniCard,
  UcRegisterSelector
};
